import { Icon } from "@sellar-io/components";
import { useRetailerNotificationIndicator } from "../useRetailerNotificationIndicator";
import { NavigationOverlay } from "./NavigationOverlay";
import { useNavigationOverlay } from "./NavigationOverlayContext.shared";
import { NotificationsNavigationContent } from "./NotificationsNavigationContent";

export const NotificationsNavigationOverlay = () => {
  const hasUnread = useRetailerNotificationIndicator();
  const { closeOverlay } = useNavigationOverlay();
  return (
    <NavigationOverlay
      id="notifications"
      title="Notifications"
      trigger={(props) => (
        <button
          {...props}
          type="button"
          aria-label={
            hasUnread ? "Notifications, unread activity" : "Notifications"
          }
          className="relative inline-flex size-8 shrink-0 items-center justify-center rounded-full p-0 text-zinc-800 hover:text-[#a34fd2] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-purple-600 aria-expanded:text-[#8c23c7]"
        >
          <Icon icon="BELL_OUTLINE" size="20px" />
          {hasUnread && (
            <span
              aria-hidden="true"
              className="absolute top-0.5 right-0.5 size-1.5 rounded-full bg-[#a34fd2]"
            />
          )}
        </button>
      )}
    >
      <NotificationsNavigationContent
        onClose={() => closeOverlay("notifications")}
      />
    </NavigationOverlay>
  );
};
